import { TAB_KEY } from '@/shared/config';
import { BeatDataEffect } from '@/widgets/beats';
import { EventsDataEffect } from '@/widgets/ecg-events';
import { HrSummaryDataEffect } from '@/widgets/hr-summary';
import { ReportDataEffect } from '@/widgets/pdf-report';
import { StripsDataEffect } from '@/widgets/strips-management';

type DataEffectProps = { keyRecoil: string; tab?: string };

/**
 * Mounts the data-side effect component belonging to the active report tab. Switches on the tab id to render the beat, events, strips, report or HR summary effect with the given store key, and renders nothing for any other tab.
 *
 * @param keyRecoil - Store key identifying the report tab's slice of state.
 * @param tab - The active tab id selecting which effect to mount.
 * @returns The data effect component for the tab, or null.
 */
const DataEffect = ({ keyRecoil, tab }: DataEffectProps) => {
  switch (tab) {
    case TAB_KEY.BEATS:
      return <BeatDataEffect keyRecoil={keyRecoil} />;
    case TAB_KEY.ECG_EVENTS:
      return <EventsDataEffect keyRecoil={keyRecoil} />;
    case TAB_KEY.STRIPS_MANAGEMENT:
      return <StripsDataEffect keyRecoil={keyRecoil} />;
    case TAB_KEY.PDF_REPORT:
      return <ReportDataEffect keyRecoil={keyRecoil} />;
    case TAB_KEY.HR_SUMMARY:
      return <HrSummaryDataEffect keyRecoil={keyRecoil} />;
    default:
      return null;
  }
};

export default DataEffect;
